import * as React from "react";
import BaseUI, { IBaseUI } from "src/engine/ui/BaseUI";
import IUIItem from "src/engine/interface/IUIItem";
import "./Page.scss";
import UIManifest from "src/engine/ui/UIManifest";
import PageContext from "./PageContext";
import SourceEngine from "src/engine/source/SourceEngine";
import GameConfig from "src/GameConfig";
import SourceCenter from "src/engine/SourceCenter";
import Http from "src/lib/http/Http";
import SourceHelper from "src/engineEditor/pages/SourceHelper";
import PluginHttp from "src/lib/http/PluginHttp";
import Config from "src/engine/const/Config";
import { METHOD } from "src/lib/http/HttpEmun";
import AutoBind from "src/engine/decorator/AutoBind";
import Cookie from "src/lib/utils/storage/Cookie";
import Handle from "src/engine/SourceCenter/utils/Handle";
// import { IModuleProps } from "../source/ModuleQuery";
import Manifest from "src/engine/Manifest";
import Utils from "src/lib/utils/Utils";
import Storage from "src/lib/utils/storage/Storage";
import StorageType from "src/lib/utils/storage/StorageType";

interface IModuleSort {
    label: string;
    sortkey: string;
    sortType: "down" | "up";
}

export interface ITotalSourceParams {
    sources: string;
    label: string;
    value: string;
}

interface IPage extends IBaseUI {
    content: IUIItem[];
    hidden: boolean;
    intent: any;
    module: IUIItem[];
    sources: IUIItem[];
    modals: IUIItem[];
    jjHistory: any;
    bridge: any;
    last: boolean;
    registerModal?: any;
    moduleNum?: any;
    dataStyle?: any; //刘海屏适配
    notchMap?: any;
    hiddenBar?: boolean;
    isPC?: boolean | string;
    preload?: string[];
    // 数据模块是否触发页面完成渲染（静态化属性）
    shouldDispatchModule?: string;
    weixinUrl?: string;
    weixinLoginUrl?: string;
    moduleSort?: IModuleSort[];
    totalSourceParams?: ITotalSourceParams[];
    mobileStyle?: any;//编辑环境下切换设备类型
    changeUtils?: string;//编辑环境下切换设备类型执行的数据源
    checkLoginType?: "page" | "url";
    loginName?: string;//跳转登录地址
}

interface IModalItem {
    ename: string;
    modelProps?: any;
    uiItem: IUIItem;
}

export type IPageModal = Omit<IModalItem, "uiItem">;

export enum StatType {
    //页面事件
    PAGE = "page",
    //点击事件
    CLICK = "click",
    //停留时长
    TIME = "time",
    //曝光类型
    Exposure = "exposure",
}

interface IState {
    modalItems: IModalItem[];
    wxShow: boolean;
}

@UIManifest.declare("PCPage", "页面组件", UIManifest.Type.PageMgr)
class Page extends BaseUI<IPage, IState> {
    //回调监听器
    backListeners: any[] = [];

    childSourceManager: SourceCenter | null;

    constructor(props: IPage) {
        super(props);
        this.state = {
            modalItems: [],
            wxShow: false,
        };

    }

    checkLogin() {
        const { checkLoginType, pageName, url, editing = false } = this.props as any;
        if (checkLoginType && !editing) {
            const userId = new Storage(StorageType.Cookie).get("User_Id", "111");
            //判断是否已经登录
            if (userId !== "111") return;
            switch (checkLoginType) {
                case "page":
                    if (pageName) this.startPage(pageName, { init: -1 });
                    break;
                case "url":
                    if (url) window.location.href = url;
                    break;
            }
        }
    }

    registerBack = (close: any) => {
        this.backListeners.push(close);
        // let { modals } = this.state;
        // modals = [...modals, { uiItem, props }];
        // this.setState({ modals });
    };

    pageBack = (): boolean => {
        const { backListeners } = this;

        if (backListeners.length === 0) {
            const { index } = this.props as any;
            if (index === 0) this.endTime();
            return false;
        }
        const last = backListeners[backListeners.length - 1];
        //抛出
        backListeners.pop();
        const type = !last();
        //调用
        if (type) {
            return this.pageBack();
        }

        const { modalItems = [] } = this.state;
        if (modalItems.length === 0) return true;
        modalItems.pop();
        this.setState({ modalItems: [...modalItems] });
        return false;
    };

    time: number;

    @AutoBind
    toLoginWeChat() {
        const { weixinUrl, weixinLoginUrl } = this.props;
        if (weixinUrl) {
            PluginHttp.ajax({}, () => { }, {
                url: `${Config.API}${weixinLoginUrl || "official-media/user/gm/delCookie"}`,
                method: METHOD.GET,
                headers: {},
                success: (res) => {
                    //res为true说明需要跳转微信登录
                    if (res.data && res.data.DATA) {
                        this.setCookieLocal();
                        if (GameConfig.cmsVersion === "0") console.log(`[Page] wechat to ${weixinUrl}`);
                        else window.location.href = weixinUrl;
                    } else {
                        this.setState({ wxShow: true });
                    }
                },
                error: (errr) => {
                    console.log(errr);
                },
            });
        }
    }

    @AutoBind
    setCookieLocal() {
        const { wxUrlToCookie } = this.props as any;
        if (!wxUrlToCookie || wxUrlToCookie.length === 0) return;
        const manager = this.childSourceManager;
        if (manager) {
            const handle = new Handle(manager.mManager);
            const cookieMap = handle._getExtendList(wxUrlToCookie);
            Object.keys(cookieMap).map((key: string) => {
                Cookie.setItem(key, cookieMap[key], { path: "/" });
            });
        }
    }

    UNSAFE_componentWillMount() {
        this.toLoginWeChat();
    }
    componentDidMount() {
        this.checkLogin();
        const { registerModal, preload = [] } = this.props;
        this.setCookieLocal();

        if (registerModal) {
            registerModal(this.pageBack);
        }
        //添加统计
        this.stat({}, StatType.PAGE);
        this.initTime();
        this.setTimeout(() => {
            this.preLoadImg(preload);
        }, 300);
        return;
    }

    showModal = (modal: IModalItem, args: any = {}) => {
        modal = { ...modal };
        const { modals = [] } = this.props;
        for (const item of modals) {
            if (item.info.ename === modal.ename) {
                modal.uiItem = item;
                break;
            }
        }
        const { modalItems } = this.state;
        let items = [...modalItems];
        if (modal.uiItem.props.clear || args.clear) items = [];
        items.push(modal);
        this.setState({ modalItems: items });
    };

    preLoadImg(imgs: any[] = []) {
        const images: any = [];
        for (let i = 0; i < imgs.length; i++) {
            const url = imgs[i].value;
            if (url.indexOf(".json") > 0) {
                Http.ajaxJson({ url });
            } else {
                images[i] = new Image();
                images[i].src = url;
            }
        }
    }

    initTime() {
        this.time = new Date().valueOf();
    }
    uploadDuration: boolean;
    endTime() {
        //解决多次点击返回时长多次上传问题
        if (this.uploadDuration) {
            return;
        }
        this.uploadDuration = true;
        const duration = new Date().valueOf() - this.time;
        this.stat({ duration }, StatType.TIME);
    }

    UNSAFE_componentWillReceiveProps(nextProps: IPage) {
        if (nextProps.last !== this.props.last) {
            if (nextProps.last === true) {
                this.initTime();
            } else {
                this.endTime();
            }
        }
    }

    componentWillUnmount() {
        this.endTime();
    }

    renderBridge = (uiItems?: IUIItem[], props?: any) => {
        const { bridge } = this.props;
        if (bridge && bridge.length > 0) {
            //modalItems:处理旧版使用BridgeProvider的项目的物理键返回关闭modal问题
            return this.renderChildren(bridge, { props, content: uiItems, back: this.pageBack, modalItems: this.state.modalItems });
        }
        return this.renderChildren(uiItems, props);
    };

    renderModules(): JSX.Element | null {
        return null;
    }

    getSources(flag: boolean = false) {
        const { sources = [], intent, module, totalSourceParams, moduleNum } = this.props;
        const ret = {
            ...SourceEngine.createByModules(module, moduleNum),
            ...SourceEngine.create(sources, flag, intent, totalSourceParams),
        };
        return ret;
    }

    renderSource = (uiItems?: IUIItem[], props?: any) => {
        const { uiItem, stores } = this.props as any;
        // if (sources.length === 0) return this.renderBridge(uiItems, props);
        return (
            <SourceCenter
                uiItem={Manifest.ui()}
                ename={uiItem.info.ename}
                stores={stores}
                sources={this.getSources(false)}
                ref={(refs) => (this.childSourceManager = refs)}
            >
                {/* {this.renderChildren(uiItems, props)} */}
                {this.renderBridge(uiItems, props)}
                {this.renderModals()}
                {this.renderModules()}
            </SourceCenter>
        );
    };

    removeModal(item: IModalItem) {
        const { modalItems } = this.state;
        const indexOf = modalItems.indexOf(item);
        this.setState({ modalItems: SourceHelper.remove(modalItems, indexOf) });
    }

    renderModals() {
        const { modalItems = [] } = this.state;
        return modalItems.map((item) => {
            return this.renderChildren([item.uiItem], { ...item.modelProps, afterClose: this.removeModal.bind(this, item), visible: true, showPopup: true });
        });
    }

    stat(info: any, type: StatType = StatType.CLICK) {
        const aWindow: any = window;
        if (!aWindow.Logger) return;
        const { uiItem, intent = {} } = this.props;
        // const intent = this.getIntent();
        const statInfo = {
            plt: "webcloud",
            //租户ID
            gameId: GameConfig.gameId,
            // 服务
            server: GameConfig.server,
            //活动id
            activityId: `${GameConfig.server}_${GameConfig.gameId}`,
            //页面id
            pageId: uiItem.info.ename,
            ...info,
        };
        //统计文章信息
        if (!statInfo.artId && intent && intent.i && !isNaN(Number(intent.i))) statInfo.artId = intent.i;
        //按钮统计
        aWindow.Logger.profession(type, statInfo);
    }

    // renderModals() {
    //     const { modals = [] } = this.state;
    //     if (modals.length === 0) return null;

    //     const uiItem = { info: { ename: "", cname: "" }, props: {}, ui: "Box" };
    //     return (
    //         <div className="modals" onClick={this.pageBack}>
    //             {this.panel((context: IPanelContext) => {
    //                 return modals.map((item, key) => {
    //                     return (
    //                         <Box key={key} onClick={this.pageBack} uiItem={uiItem}>
    //                             {/* {this.renderUIItem(item.uiItem, context, { key, ...item.uiItem, ...item.props })} */}
    //                             {this.renderUIItem(item.uiItem, context, { key, ...item.props })}
    //                         </Box>
    //                     );
    //                 });
    //             })}
    //         </div>
    //     );
    // }
    getNotch = () => {
        const { notchMap, dataSource } = this.props;
        let style = {};
        if (dataSource) {
            if (notchMap && notchMap.length > 0) {
                notchMap.map((item: any) => {
                    if (Number(dataSource[item.label]) > 0) {
                        style = { ...style, ...this.props[item.value] };
                    }
                });
                return style;
            }
        }
        return {};
    };

    pageRef = () => {
        return this["mPage"];
    }

    renderAct() {
        const { content = [], hidden, intent, uiItem, last, hiddenBar, moduleNum, weixinUrl } = this.props;
        let wechatCN = "";
        if (weixinUrl && this.state.wxShow === false && window.location.href.indexOf("localhost") <= -1) {
            wechatCN = "true";
        }
        return (
            <div ref={Utils.ref(this, "mPage")} className={`react-page ${hidden} ${wechatCN} ${hiddenBar ? "react-page-hidden-bar" : ""}`} style={this.getStyle()}>
                <div style={this.getNotch()}>
                    <PageContext.context.Provider
                        value={{
                            intent: intent || this.props.jjHistory?.hash?.get()?.props || {},
                            registerBackListener: this.registerBack,
                            showModal: this.showModal,
                            pageBack: this.pageBack,
                            pageName: uiItem.info.ename,
                            pageRef: this.pageRef,
                            stat: this.stat.bind(this),
                            pageLast: last,
                            moduleNum,
                        }}
                    >
                        {this.renderSource(content, { jjHistory: this.props.jjHistory, pageLast: last })}
                    </PageContext.context.Provider>
                </div>
            </div>
        );
    }
}

export default Page;
